import { render } from "./Edit.vue?vue&type=template&id=b7af504c&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=b7af504c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7af504c"],['__file',"src/views/WebOrders/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7af504c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7af504c', __exports__)) {
    api.reload('b7af504c', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=b7af504c&scoped=true", () => {
    api.rerender('b7af504c', render)
  })

}


export default __exports__